function getLLEsubdomain(param) {
  const host = window.location.host;
  let subdomain = '';
  if (host?.indexOf('dev') !== -1) {
    subdomain = param === 'dash' ? 'dev-' : 'dev.';
  }
  if (host?.indexOf('qa02') !== -1) {
    subdomain = param === 'dash' ? 'qa02-' : 'qa02.';
  }
  if (host?.indexOf('preprod') !== -1) {
    subdomain = param === 'dash' ? 'preprod-' : 'preprod.';
  }
  if (host?.indexOf('sandbox') !== -1 || host?.indexOf('localhost') !== -1) {
    subdomain = param === 'dash' ? 'sandbox-' : 'sandbox.';
  }
  return subdomain;
}
export default getLLEsubdomain;
